module.exports = __webpack_public_path__ + "static/media/tdfBanner@4x.e8f716fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tdfBanner@4x.png
// module id = 1861
// module chunks = 0 1